import React from 'react';
import I18n from 'app/i18n';
import {TelegramIcon} from './AffiliatesIcons';
import {PARTNER_TELEGRAM_URL} from './affiliatesLinks';

const QUESTIONS = [
    ['q1', 'a1'],
    ['q2', 'a2'],
    ['q3', 'a3'],
    ['q4', 'a4'],
    ['q5', 'a5'],
    ['q6', 'a6']
];

const AffiliatesFaq = (): React.ReactElement => <section className="sec" id="faq">
    <div className="wrap">
        <div className="sec-head rv">
            <div>
                <div className="eyebrow">{I18n.t('affiliate.faq_ey')}</div>
                <h2>FAQ</h2>
            </div>
        </div>
        <div className="faq">
            {QUESTIONS.map(([question, answer]) => <details className="rv" key={question}>
                <summary>
                    <span>{I18n.t(`affiliate.${question}`)}</span>
                    <span className="pm"/>
                </summary>
                <div className="ans">{I18n.t(`affiliate.${answer}`)}</div>
            </details>)}
        </div>
        <div className="faq-more rv">
            <TelegramIcon/>
            <span>
                <span>{I18n.t('affiliate.more')}</span>
                {' '}
                <a href={PARTNER_TELEGRAM_URL} target="_blank" rel="noopener noreferrer">@iboom67</a>
            </span>
        </div>
    </div>
</section>;

export default AffiliatesFaq;
